import React, { useContext, useEffect, useState } from 'react'

import { DBContext } from '../../../contexts/databases'
import { CharacterContext } from '../../../contexts/character'

import CardSelect from './CardSelect'
import EnchantSelect from './EnchantSelect'
import OptionSelect from './OptionSelect'

import Select from 'react-select'

import * as jobsID from '../../../data/jobID'
import { UIContext } from '../../../contexts/ui'

function EquipSelect(props) {
	const [options, setOptions] = useState([])
	const [selectedValue, setSelectedValue] = useState([
		{
			value: 0,
			label: 'No ' + props.Location,
		},
	])
	const [selectedRefineValue, setSelectedRefineValue] = useState([
		{
			value: 0,
			label: '+0',
		},
	])
	const [ammoSelectedValue, setAmmoSelectedValue] = useState([
		{
			value: 0,
			label: 'No ammo',
		},
	])
	const [ammoOptions, setAmmoOptions] = useState([])
	const [isAmmoAllowed, setIsAmmoAllowed] = useState(false)
	const { item_db_equip, Item, item_ammo } = useContext(DBContext)
	const {
		job,
		inventory,
		replaceItemInInventory,
		maxRefine,
		searchAndSetOptions,
	} = useContext(CharacterContext)
	const { customStyles, customStylesDisabled } = useContext(UIContext)
	const changeLastSelectedItem = props.setLastSelectedItem

	const refine = []
	if (props.Refinable) {
		for (let i = 0; i <= props.MaxRefine; i++)
			refine.push({
				value: i,
				label: '+' + i,
			})
	}

	useEffect(() => {
		let newOptions = []
		newOptions.push({
			value: 0,
			label: 'No ' + props.Location,
			key: 'eq' + 0,
		})
		let filteredDB = []
		filteredDB = filterItems(item_db_equip, props.Location, job)
		filteredDB.forEach((itm) => {
			newOptions.push({
				value: itm.Id,
				label: itm.Slots ? itm.Name + '[' + itm.Slots + ']' : itm.Name,
				key: 'eq' + itm.Id,
			})
		})
		setOptions(newOptions)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_db_equip, job])
	useEffect(() => {
		if (props.Location === 'Right_Hand') {
			let jobsEligibleForAmmo = [
				'ARCHER',
				'THIEF',
				'HUNTER',
				'BARD',
				'DANCER',
				'ROGUE',
				'GUNSLINGER',
				'REBELLION',
				'NINJA',
				'KAGEROU',
				'OBORO',
				'MECHANIC',
				'GENETIC',
			]
			if (
				jobsEligibleForAmmo.includes(
					jobsID.getFormatedBaseClassName(job),
				) ||
				jobsEligibleForAmmo.includes(jobsID.getThirdClassName(job))
			) {
				setIsAmmoAllowed(true)
				let baseJob = jobsID
					.getFormatedBaseClassName(job)
					.toLocaleUpperCase()
				let ammoList = []
				let newOptions = []
				newOptions.push({
					value: 0,
					label: 'No ammo',
					key: 'ammo' + 0,
				})
				switch (baseJob) {
					case 'ARCHER':
					case 'THIEF':
					case 'HUNTER':
					case 'BARD':
					case 'DANCER':
					case 'ROGUE':
						// console.log('Bow')
						ammoList = item_ammo.filter(
							(ammo) => ammo.SubType === 'Arrow',
						)

						break
					case 'GUNSLINGER':
					case 'REBELLION':
						ammoList = item_ammo.filter(
							(ammo) =>
								ammo.SubType === 'Bullet' ||
								ammo.SubType === 'Grenade',
						)

						break
					case 'NINJA':
					case 'KAGEROU':
					case 'OBORO':
						ammoList = item_ammo.filter(
							(ammo) =>
								ammo.SubType === 'Kunai' ||
								ammo.SubType === 'Shuriken',
						)

						break
					case 'BLACKSMITH':
					case 'ALCHEMIST':
						ammoList = item_ammo.filter(
							(ammo) => ammo.SubType === 'Cannonball',
						)
						break
					default:
						console.log('No ammunition found for this class')
						break
				}
				ammoList.forEach((itm) => {
					newOptions.push({
						value: itm.Id,
						label: itm.Slots
							? itm.Name + '[' + itm.Slots + ']'
							: itm.Name,
						key: 'eq' + itm.Id,
					})
				})
				setAmmoOptions(newOptions)
			} else {
				setIsAmmoAllowed(false)
			}
		}
	}, [item_ammo, job, props.Location])
	useEffect(() => {
		searchAndSetOptions(
			options,
			inventory[props.Location]?.Id,
			setSelectedValue,
		)
		searchAndSetOptions(
			refine,
			inventory[props.Location]?.refine,
			setSelectedRefineValue,
		)
		//ammo
		searchAndSetOptions(
			ammoOptions,
			inventory['Ammo']?.Id,
			setAmmoSelectedValue,
		)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inventory[props.Location], options, inventory['Ammo'], ammoOptions])

	return (
		<div className='horizontal2'>
			<div className='div'>
				{props.Refinable ? (
					<Select
						menuPlacement='auto'
						styles={customStyles}
						value={selectedRefineValue}
						id={'ref' + props.id}
						className='refine'
						onChange={(event) => {
							//Create a new Item
							let newItem = new Item(
								props.Location,
								maxRefine[props.Location] > 0,
							)
							//Copy current Item
							newItem.setItem(inventory[props.Location])
							//change refine level
							newItem.setRefine(Number(event.value))
							//restore cards
							newItem.CardSlots.map((cardSlot, index) =>
								cardSlot.changeSlot(
									inventory[props.Location].CardSlots[index],
								),
							)
							//restore options
							newItem.setOptions(inventory[props.Location].Options)
							//apply new Item to Item slot
							replaceItemInInventory(newItem)
						}}
						options={refine}
					/>
				) : (
					<div className='refine'></div>
				)}

				<Select
					menuPlacement='auto'
					value={selectedValue}
					styles={customStyles}
					className='equip'
					id={props.id}
					onChange={(event) => {
						changeLastSelectedItem(event.value)
						let newItem = new Item(
							props.Location,
							maxRefine[props.Location] > 0,
						)
						let newItemFromDB = item_db_equip.find(
							(equip) => equip.Id === parseInt(event.value),
						)

						if (newItemFromDB) {
							newItem.setItem(newItemFromDB)
							// console.log(newItem)
							Object.entries(newItem.CardSlots).forEach(
								([Slot, Compound]) => {
									if (
										Compound.Type !== 'None' &&
										Compound.Type ===
											inventory[props.Location].CardSlots[
												Slot
											].Type
									)
										newItem.CardSlots[Slot].changeSlot(
											inventory[props.Location].CardSlots[
												Slot
											],
										)
									if (
										inventory[props.Location].CardSlots[
											Slot
										].Type === 'Enchant' ||
										Compound.Type === 'None'
									)
										Compound.clearSlot()
									// 		if (Compound.Id !== 0)
									// 			newItem.CardSlots[Slot].changeSlot(
									// 				Compound,
									// 			)
								},
							)
						}
						if (props.Refinable)
							newItem.setRefine(inventory[props.Location].refine)
						// console.log('newItem.CardSlots')
						// console.log(newItem.CardSlots)
						// newItem.CardSlots.map((cardSlot, index) =>
						// 	newItem.Slots > index
						// 		? cardSlot.changeSlot(
						// 				inventory[props.Location].CardSlots[
						// 					index
						// 				],
						// 			)
						// 		: null,
						// )
						// props.SetFunction(newItem)
						replaceItemInInventory(newItem)
					}}
					// onChange={handleChange}
					options={options}
				/>
			</div>
			<div className='cardenchant'>
				{inventory[props.Location].CardSlots.map((cardSlot, index) =>
					cardSlot.Type === 'Card' ? (
						<CardSelect
							id={'card' + inventory[props.Location].Location}
							Location={inventory[props.Location].Location}
							Slot={index}
							key={
								inventory[props.Location].Location +
								'Slot' +
								index
								// (inventory[key] + 1)
							}
							styles={customStyles}
							setLastSelectedItem={props.setLastSelectedItem}
						/>
					) : cardSlot.Type === 'Enchant' ? (
						// ) : isEnchantable(inventory[props.Location].Id) ? (
						<EnchantSelect
							id={
								'ench' +
								inventory[props.Location].Location +
								'1'
							}
							Location={inventory[props.Location].Location}
							setLastSelectedItem={props.setLastSelectedItem}
							ItemID={inventory[props.Location].Id}
							Slot={index}
							key={
								inventory[props.Location].Location +
								'Ench' +
								index
								// (inventory[key] + 1)
							}
							styles={customStyles}
						/>
					) : (
						// ) : null,
						<CardSelect
							id={'card' + inventory[props.Location].Location}
							Location={inventory[props.Location].Location}
							Slot={index}
							key={
								inventory[props.Location].Location +
								'Slot' +
								index
								// (inventory[key] + 1)
							}
							isDisabled={true}
							styles={customStylesDisabled}
							setLastSelectedItem={props.setLastSelectedItem}
						/>
					),
				)}
			</div>
			<OptionSelect
				Location={props.Location}
				setLastSelectedItem={props.setLastSelectedItem}
			/>
			<div className='ammo'>
				{isAmmoAllowed ? (
					<Select
						menuPlacement='auto'
						value={ammoSelectedValue}
						styles={customStyles}
						// className='ammoSelect'
						// id={props.id}
						onChange={(event) => {
							setAmmoSelectedValue()
							changeLastSelectedItem(event.value)
							let newItem = new Item('Ammo', false)
							let newItemFromDB = item_ammo.find(
								(ammo) => ammo.Id === parseInt(event.value),
							)
							if (newItemFromDB) {
								newItem.setItem(newItemFromDB)
								// console.log(newItem)
							}
							replaceItemInInventory(newItem)
						}}
						// onChange={handleChange}
						options={ammoOptions}
					/>
				) : null}
			</div>
		</div>
	)
}

function filterItems(item_db_equip, Location, job) {
	let Location2 = Location
	if (Location === 'Right_Accessory' || Location === 'Left_Accessory')
		Location2 = 'Both_Accessory'
	if (Location === 'Right_Hand') Location2 = 'Both_Hand'
	let formatedBaseClassName = jobsID.getFormatedBaseClassName(job)
	if (
		Location === 'Left_Hand' &&
		(formatedBaseClassName === 'Assassin' ||
			formatedBaseClassName === 'Kagerou' ||
			formatedBaseClassName === 'Oboro')
	)
		Location2 = 'Right_Hand'
	let gender = ''
	if (
		formatedBaseClassName === 'Bard' ||
		formatedBaseClassName === 'Dancer' ||
		formatedBaseClassName === 'Kagerou' ||
		formatedBaseClassName === 'Oboro'
	) {
		gender = job & jobsID.IS_MALE ? 'Male' : 'Female'
		if (
			formatedBaseClassName === 'Bard' ||
			formatedBaseClassName === 'Dancer'
		)
			formatedBaseClassName = 'BardDancer'
		else formatedBaseClassName = 'KagerouOboro'
	}
	if (formatedBaseClassName === 'Star_Gladiator')
		formatedBaseClassName = 'StarGladiator'
	if (formatedBaseClassName === 'Soul_Linker')
		formatedBaseClassName = 'SoulLinker'

	let filteredDB = item_db_equip.filter(
		(eq) =>
			(eq.Locations?.[Location] || eq.Locations?.[Location2]) &&
			(!eq.Jobs || eq.Jobs?.[formatedBaseClassName]) &&
			(!eq.Gender || eq.Gender === gender),
	)
	return filteredDB
}

export default EquipSelect
